import { cr, URLS } from "fire-wind-water";
import { settings } from "../common/setting";
import { user } from "../user";
import { scmsService } from "../services/site";
class Path {
  $skelem = ".sk-cms-detail-dom";
  articleDetail = "";
  fileDetail = "";
  isPreview: boolean = settings.isPreview;
  tid: string = settings.tenantId || URLS.getURL("tid") || (window['siteParams']?window['siteParams'].tid:null);
  sid: string = settings.siteId || URLS.getURL("sid") || (URLS.getURL("des")?null : (window['siteParams']?window['siteParams'].sid:null));
  cy: string = settings.category || URLS.getURL("cy") || (URLS.getURL("des")?null : (window['siteParams']?window['siteParams'].cy:null));
  t: string = settings.t || URLS.getURL("t") || (URLS.getURL("des")?null :  (window['siteParams']? window['siteParams'].t:null));
  menuId: string = settings.menuId || URLS.getURL("menuId");
  pid = "";

  skAfterViewChecked(): void {
    if (this.isPreview) {
      cr.each(settings.page.items, (d) => {
        if (d.usePages === "articleinfo") {
          this.pid = d.id;
          this.articleDetail = this.menuId
            ? `./articleInfo.html?tid=${this.tid}&sid=${this.sid}&pid=${this.pid}&cy=${this.cy}&t=${this.t}&menuId=${this.menuId}`
            : `./articleInfo.html?tid=${this.tid}&sid=${this.sid}&pid=${this.pid}&cy=${this.cy}&t=${this.t}`;
        }
      });
    }
  }

  goOuter(e, url, id, title): void {
    const info = {
      tenantId: settings.tenantId,
      siteId: settings.siteId,
      globalUserId: user.globalUserId,
      openId: user.openId || "",
      channel_code: settings.channel_code,
      memberId: user.memberId,
      sess: user.session,
      objTitle: title,
      objId: id,
      actionKey: "MIMAGETEXT",
    };
    scmsService.browse(info).subscribe((res) => {
      res;
    });
    console.log(info);
    window.open(url);
  }
}

export { Path };
